import * as React from "react";
import { ListItem } from "material-ui";

interface FocusListItemProps {
    style: any;
    containerElement?: JSX.Element;
    primaryText: React.ReactNode;
    secondaryText?: React.ReactNode;
    isFocused: boolean;
    onRequestClose: () => void;
}

export default class FocusListItem extends React.Component<FocusListItemProps> {
    element: ListItem;

    componentDidMount() {
        if (this.props.isFocused) {
            this.element.applyFocusState("keyboard-focused");
        }
    }

    componentDidUpdate(prevProps: FocusListItemProps, prevState: FocusListItemProps) {
        if (prevProps.isFocused === this.props.isFocused) {
            return;
        }

        if (this.props.isFocused) {
            this.element.applyFocusState("keyboard-focused");
        }
    }

    render() {
        return <ListItem
            ref={this.setRef}
            style={this.props.style}
            containerElement={this.props.containerElement}
            primaryText={this.props.primaryText}
            secondaryText={this.props.secondaryText}
            onClick={this.props.onRequestClose} />;
    }

    private setRef = (el: ListItem) => {
        this.element = el;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/FocusListItem/FocustListItem.tsx